import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { AppEventDispatcher } from './../../../utils/AppEventDispatcher';
import { TweenMax, Quint, Power2, Sine } from 'gsap';
import { AutenticationEventType } from './../../autentication.event.type';
import { Router } from '@angular/router';
import { AutenticationService } from './../../autentication.service';
import { EventTypes } from './../../../shared/EventTypes';
import { Question } from './../../models/question';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AuthMessage } from './../../models/auth-message';

@Component({
	selector: 'app-security-check-registration-registration',
	templateUrl: './registration.component.html',
	styleUrls: ['./registration.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class RegistrationComponent implements OnInit {

	view = '[data-component="security-check-registration"]';
	active = false;
	loading = false;
	canSend = false;
	questionActive = 0;
	questionsCombo = {};
	questions: Question[];
	answers: Question[] = [];

	public form: FormGroup;


	constructor(
		private router: Router,
		private authService: AutenticationService,
		private formBuilder: FormBuilder
	) {
		this.form = formBuilder.group({
			'question': [null, Validators.required],
			'answer': [null, Validators.required]
		});
	}

	ngOnInit() {
		AppEventDispatcher.listen(AutenticationEventType.SECURITY_CHECK_REGISTRATION.REGISTRATION, (data: any) => {
			if (data.show) {
				this.getSecurityQuestions(data);
			}
		});
	}

	getSecurityQuestions(data) {
		this.authService.getForRegistrationSecurityQuestions().subscribe(data => {
			this.questionsCombo = data;
			this.questionsCombo = this.sliceQuestions(this.questionsCombo, 6);

			this.questions = this.questionsCombo[0];
			this.active = true;
			this.show();
		}, error => {
			AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
		});
	}

	sliceQuestions(base, max) {
		var res = [];
		for (var i = 0; i < base.length; i = i+(max)) {
				res.push(base.slice(i,(i+max)));
		}
		return res;
	}

	show() {
		TweenMax.to('[data-component="security-check-registration"]', .8, {left: 0, ease: Quint.easeOut, onComplete: () => {}});
		TweenMax.to(this.view, .8, { left: 0, ease: Quint.easeOut, onComplete: () => {}});
	}

	hide() {
		TweenMax.to(this.view, .8, {
			left: '-100%', ease: Quint.easeOut, onComplete: () => {
				this.active = false;
			}
		});
	}

	send() {
		this.loading = true;
		this.authService.saveSecurityQuestions(this.answers).subscribe(data => {
			this.hide();

			TweenMax.to('[data-component="login"]', .8, { width: '100%', height: 300, ease: Sine.easeOut});
			TweenMax.to('[data-component="login"] .logo', .8, { scale: .85, top: 25, ease: Sine.easeOut});

			const message = new AuthMessage();

			message.buttonTitle = 'Acessar';
			message.delay = .2;
			message.type = 'middle';
			message.eventData = { fromDefinePassword: true };
			message.delayToDispatchEvent = 0;
			message.hasButton = true;
			message.title = 'Suas perguntas de segurança foram definidas com sucesso!';
			message.text = '';
			message.withPreload = true;

			AppEventDispatcher.dispatch(AutenticationEventType.LOGIN.AUTH_MESSAGE, message);

			this.loading = false;

		}, error => {
			AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
		});
	}

	nextAnswer() {
		TweenMax.to(this.view + ' .question-step', .8, {
			left: '-100%', ease: Quint.easeOut, onComplete: () => {

				const questionSelected = this.questions[this.form.value.question];

				const answer = {
					code: questionSelected.code,
					description: questionSelected.description,
					answer: this.form.value.answer
				}

				this.answers.push(answer);

				this.questionActive++;

				this.form.controls.question.setValue(null);
				this.form.controls.answer.setValue('');
				this.canSend = false;

				if (this.questionActive === 3) {
					this.send();
				} else {
					this.questions = this.questionsCombo[this.questionActive];

					$(this.view + ' .question-step').css('left', '100%');
					TweenMax.to(this.view + ' .question-step', .8, {
						left: 0, ease: Quint.easeOut, onComplete: () => {
						}
					});
				}
			}
		});
	}

	answerChange(event) {

		if ((this.form.controls.answer.valid) && (this.form.controls.question.valid)) {
			this.canSend = true;
		} else {
			this.canSend = false;
		}

	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/autentication/security-check-registration/registration/registration.component.ts